import { render, staticRenderFns } from "./ProductsSelector.vue?vue&type=template&id=5b7bfb41&scoped=true"
import script from "./ProductsSelector.vue?vue&type=script&lang=js"
export * from "./ProductsSelector.vue?vue&type=script&lang=js"
import style0 from "./ProductsSelector.vue?vue&type=style&index=0&id=5b7bfb41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7bfb41",
  null
  
)

export default component.exports